import TreatPackDialogSelector from './treatpack-dialog-selector.vue'

TreatPackDialogSelector.install = function (Vue) {
	Vue.component(TreatPackDialogSelector.name, TreatPackDialogSelector);
}

export default TreatPackDialogSelector;